module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAC4jAAAuIwF4pT92AAABBElEQVRIibWWYZGDMBBGX2PgkNAqaOoACZWAhJNQCZVQCUjoOUgdIAEH3/1IMkMZkgJN3sz+Yci+ZMjucpDERlrAAePqFZJy0Uj6lfTUMk7SXdIxlyeX/JZInOIR1q2S2LDDPYyS2k8SG178li4laQoJFPLYJUlfSBBxc0lbWBDpppLSp4gMkjjIF+PmitzAxeAruCatAWxlSWOAprLEmsoCAAxbuuk+nMG37ZoM8QqPwE8lySl+k76S4A8YYsUfK1X8VbMGeS8seCrR6vcOqzmjJiN5aex+K3qbJUuSKEr9OHzCzQUpSYxOvlWv3f0tlSvWSY5rCAucJ89fwIC//j2ZzvEPyP8iIB1K9QQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/games/motion/PointNORMAL.png
// module id = DIYW
// module chunks = 2